import purchaseApis from '../../service/apis/purchase.js'
import { stat } from 'fs'
// import { formatRequestData } from '../../plugins/helper'

export const GET_PRICELIST = 'GET_PRICELIST'
export const SET_PRICELIST = 'SET_PRICELIST'
export const SET_PRODUCTID = 'SET_PRODUCTID'
export const GRT_MESSAGEINFOLIST = 'GRT_MESSAGEINFOLIST'
export const GET_COUPONDOCLIST = 'GET_COUPONDOCLIST'
export const GET_DEFAULTCOUPON = 'GET_DEFAULTCOUPON'
export const GET_AMOUNT = 'GET_AMOUNT'
export const SET_ORDERINFO = 'SET_ORDERINFO'
export const SET_ORDERINFO_FROM_GUIDE = 'SET_ORDERINFO_FROM_GUIDE'
export const GET_ORDERINFOFORCOPY = 'GET_ORDERINFOFORCOPY'
export const GET_ORDERINFOFOREDIT = 'GET_ORDERINFOFOREDIT'
export const RESET_PURCHASESUCCESS = 'RESET_PURCHASESUCCESS'
export const INITSTATE = 'INITSTATE'

const hasprice = function (state) {
  state.pricelist = state.allAriceList[state.orderInfo.productId]
  let hasprice = false
  console.log(state)
  if (state.orderInfo.couponAmountType === 0) {
    for (let i in state.pricelist) {
      if (state.pricelist[i] === state.orderInfo.couponAmount) {
        hasprice = true
      }
    }
    if (!hasprice) {
      state.orderInfo.couponAmount = '--'
    }
  } else {
    let custom = 0 + state.orderInfo.couponAmount
    state.orderInfo.couponAmountCustom = custom
    // state.orderInfo.couponAmount = 0
  }
}

const gettime = function (date, config) {
  let month = (date.getMonth() + 1) < 10 ? '0' + (date.getMonth() + 1) : (date.getMonth() + 1)
  let time = date.getFullYear() + '-' + month + '-' + date.getDate()

  if (config === 'start') {
    time += ' 00:00:00'
  } else {
    time += ' 23:59:59'
  }
  return time
}

let startdate = new Date()
let enddate = new Date()
enddate.setTime(enddate.getTime() + 3600 * 1000 * 24 * 60) // 60天默认有效期
const starttime = gettime(startdate, 'start')
const endtime = gettime(enddate, 'end')

const state = {
  messageInfoList: [],
  messageInfoListLoading: false,
  allPriceList: [],
  couponDocList: [],
  couponDocListLoading: false,
  defaultCoupon: [],
  defaultCouponLoading: false,
  pricelist: [],
  useAddressData: {},
  PurchaseSuccess: false,
  productId: 0,
  orderInfo: {
    payType: 0, // 结算方式
    productId: '', // 券类型id
    couponType: '', // 券类型名称
    channel:3,
    // timedate: [new Date(2000, 10, 10, 10, 10), new Date(2000, 10, 11, 10, 10)], // 发券期限
    timedate: [starttime, endtime],
    // timedate: ['2018-12-13 00:00:00', '2018-12-23 23:59:59'], // 发券期限
    startTime: starttime,
    expireTime: endtime,
    expireType: 1,
    addressRadio: '1',
    batchName: '', // 券文案名称
    couponExplain: '', // 券说明
    couponTemplateId: '', // 券模板id
    smsTemplateId: '', // 短信模板ID
    smsCompanyName: '', // 短信中的公司
    couponAmount: '--', // 面额
    couponAmountCustom: '', // 自定义面额
    couponAmountType: 0,
    expire: 1, // 0为相同 1为不同
    expireDays: '', // 过期时间
    totalNumber: '', // 张数
    serviceAmount: 0, // 制券费
    totalCouponAmount: 0, // 券总金额
    discountAmount:0
  },
  orderInfoLoading: false
}

export default {
  namespaced: true,
  state: state,
  mutations: {
    [SET_PRICELIST] (state) {
      if (state.orderInfo.productId && state.allAriceList) {
        state.pricelist = state.allAriceList[state.orderInfo.productId]
      }
    },
    [GET_PRICELIST] (state, param) {
      state.allAriceList = param
      if (state.orderInfo.productId) {
        state.pricelist = state.allAriceList[state.orderInfo.productId]
        hasprice(state)
      }
    },
    [SET_PRODUCTID] (state, param) {
      state.productId = param.id
      state.orderInfo.productId = param.id
      state.orderInfo.couponType = param.coupontype
      if (state.allAriceList) {
        state.pricelist = state.allAriceList[state.orderInfo.productId]
        let couponAmount = state.orderInfo.couponAmount
        let pricelist = state.pricelist
        let match = false
        if (state.orderInfo.couponAmountType === 0) {
          for (let i = 0; i < pricelist.length; i++) {
            if (couponAmount === pricelist[i]) {
              match = true
            }
          }
          if (!match) {
            state.orderInfo.couponAmount = '--'
          }
        } else {
          let custom = 0 + state.orderInfo.couponAmount
          state.orderInfo.couponAmountCustom = custom
          // state.orderInfo.couponAmount = 0
        }
      }
    },
    [GRT_MESSAGEINFOLIST] (state, param) {
      state.messageInfoList = param
      state.messageInfoListLoading = false
    },
    [GET_COUPONDOCLIST] (state, param) {
      state.couponDocList = param
      state.couponDocListLoading = false
    },
    [GET_DEFAULTCOUPON] (state, param) {
      state.defaultCoupon = param
      state.defaultCouponLoading = false
    },
    [GET_AMOUNT] (state, param) {
      state.orderInfo.totalCouponAmount = param.data.couponTotalAmount
      state.orderInfo.serviceAmount = param.data.serviceAmount
      if(param.data.discountAmount){
        state.orderInfo.discountAmount = param.data.discountAmount
      }
      
    },
    [SET_ORDERINFO] (state, param) {
      state.orderInfo = Object.assign({}, state.orderInfo, param)
      // 处理
      state.orderInfo.timedate = [param.startTime, param.expireTime]
      if (param.expireType === 0) {
        state.orderInfo.expire = 0
      } else {
        state.orderInfo.expire = 1
        state.orderInfo.expireDays = param.expireType
      }
      if (param.couponAmountType === 1) {
        let custom = 0 + state.orderInfo.couponAmount
        state.orderInfo.couponAmountCustom = custom
        // state.orderInfo.couponAmount = 0
      } else {
        state.orderInfo.couponAmountCustom = ''
      }
      // 匹配面额
      if (state.pricelist.length === 0 && state.allAriceList) {
        hasprice(state)
      }
      state.orderInfoLoading = false
      // if (state.pricelist.length === 0 && state.allAriceList) {
      //   state.pricelist = state.allAriceList[state.orderInfo.productId]
      //   let hasprice = false
      //   for (let i in state.pricelist) {
      //     if (i === state.orderInfo.couponAmount) {
      //       hasprice = true
      //     }
      //   }
      //   if (!hasprice) {
      //     state.orderInfo.couponAmount = '--'
      //   }
      // }
    },
    [SET_ORDERINFO_FROM_GUIDE](state,param){
      state.orderInfo = Object.assign({}, state.orderInfo, param)
      hasprice(state)
    },
    [RESET_PURCHASESUCCESS] (state, param) {
      state.PurchaseSuccess = param.response
    },
    [INITSTATE] (state, param) {
      // 重置 state
      for (let p in param) {
        // debugger
        // state[p] = initState[p]
        if (p === 'orderInfo') {
          state[p] = {
            channel:3,
            payType: 0, // 结算方式
            productId: '', // 券类型id
            couponType: '', // 券类型名称
            // timedate: [new Date(2000, 10, 10, 10, 10), new Date(2000, 10, 11, 10, 10)], // 发券期限
            timedate: [starttime, endtime],
            startTime: starttime,
            expireTime: endtime,
            expireType: 0,
            addressRadio: '1',
            batchName: '', // 券文案名称
            couponExplain: '', // 券说明
            couponTemplateId: '', // 券模板id
            smsTemplateId: '', // 短信模板ID
            smsCompanyName: '', // 短信中的公司
            couponAmount: '--', // 面额
            couponAmountCustom: '', // 自定义面额
            couponAmountType: 0,
            expire: 0, // 0为相同 1为不同
            expireDays: '', // 过期时间
            totalNumber: '', // 张数
            serviceAmount: 0, // 制券费
            totalCouponAmount: 0, // 券总金额
            discountAmount:0 //折扣金额
          }
        } else if (p === 'useAddressData') {
          state[p] = {}
        }
      }
    }
  },
  actions: {
    getPriceList (context, data) {
      // let requestData = formatRequestData(data)
      purchaseApis.getPriceList(data).then(function (response) {
        context.commit(GET_PRICELIST, response.data)
      })
        .catch(function (error) {
          console.log(error)
        })
    },
    getMessageList (context) {
      context.state.messageInfoListLoading = true
      purchaseApis.getMessageList().then(function (response) {
        context.commit(GRT_MESSAGEINFOLIST, response.data)
      })
        .catch(function (error) {
          console.log(error)
        })
    },
    getCouponDocList (context) {
      context.state.couponDocListLoading = true
      purchaseApis.getCouponDocList().then(function (response) {
        context.commit(GET_COUPONDOCLIST, response.data)
      })
        .catch(function (error) {
          console.log(error)
        })
    },
    getDefaultCoupon (context) {
      context.state.defaultCouponLoading = true
      purchaseApis.getCouponDocList({groupId: '-1'}).then(function (response) {
        context.commit(GET_DEFAULTCOUPON, response.data)
      })
        .catch(function (error) {
          console.log(error)
        })
    },
    getAmount (context, data) {
      purchaseApis.getAmount(data).then(function (response) {
        context.commit(GET_AMOUNT, response)
      })
        .catch(function (error) {
          console.log(error)
        })
    },
    getOrderInfoForEdit (context, data) {
      context.state.orderInfoLoading = true
      purchaseApis.getOrderInfoForEdit(data).then(res => {
        context.commit(SET_ORDERINFO, res.data)
        // 需要先得到编辑接口返回的券 id，才能 dispatch getPriceList 来获得面额列表
        context.dispatch('getPriceList', { productId: '200,181,120,210,20' })
      })
    },
    getOrderInfoForCopy (context, data) {
      // let requestData = formatRequestData(data)
      context.state.orderInfoLoading = true
      purchaseApis.getOrderInfoForCopy(data).then(res => {
        context.commit(SET_ORDERINFO, res.data)
        // 需要先得到编辑接口返回的券 id，才能 dispatch getPriceList 来获得面额列表
        context.dispatch('getPriceList', { productId: '200,181,120,210,20' })
      })
    },
    purchaseCoupon (context, data) {
      let requestData = { ...data }
      let groupName = this.state.header.selfGroup.groupName
      requestData = Object.assign(requestData, { groupName })
      purchaseApis.purchaseCoupon(requestData).then(function (response) {
        context.commit(RESET_PURCHASESUCCESS, {response})
      })
        .catch(function (error) {
          console.log(error)
        })
    },
    initState (context, data) {
      context.commit(INITSTATE, data)
    }
  },
  getters: {
    // selfGroup: state => state.selfGroup
  }
}
